import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AtSignIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M8 1.333A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667h3.333v-1.334H8c-2.893 0-5.333-2.44-5.333-5.333 0-2.893 2.44-5.333 5.333-5.333 2.893 0 5.333 2.44 5.333 5.333v.953c0 .527-.473 1.047-1 1.047-.526 0-1-.52-1-1.047V8a3.335 3.335 0 0 0-6.666 0 3.335 3.335 0 0 0 5.693 2.353c.433.594 1.18.98 1.973.98 1.314 0 2.334-1.066 2.334-2.38V8A6.67 6.67 0 0 0 8 1.333ZM8 10c-1.107 0-2-.893-2-2s.893-2 2-2 2 .893 2 2-.893 2-2 2Z" />
  </Icon>
);

export default memo(AtSignIcon);
